import {createActions} from 'reduxsauce';

export const {Types: SearchingTypes, Creators:SearchingCreators} = createActions ({
    searchingStart: ['data'],
    searchingSuccess: ['data'],
    searchingFailure: ['error'],
    emptySearchingStart: null,
});